import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import PreparationView from "./PreparationView.jsx";
import PreparationViewIntro from "./PreparationViewIntro.jsx";
import ReviewView from "./ReviewView.jsx";
import { CustomAccountInfo } from "../../../types/customAccountInfo.js";
import { Role } from "../../../types/enums.js";
import { Project } from "../../../types/project.js";

type PreparationPageProps = {
  project: Project;
};

export default function PreparationPage({ project }: PreparationPageProps) {
  const { instance } = useMsal();
  const currentAccount = instance.getActiveAccount() as CustomAccountInfo;
  const [view, setView] = useState(
    currentAccount.idTokenClaims["role"] === Role.LocalCoordinator ? 0 : 1
  );

  function _renderPreparationView() {
    switch (view) {
      case 0:
        return <PreparationViewIntro setView={setView} />;
      case 1:
        return <PreparationView project={project} setView={setView} />;
      case 2:
        return <ReviewView setView={setView} project={project} />;

      default:
        return <div>Not Found</div>;
    }
  }

  return _renderPreparationView();
}
